<template>
  <div>
    <Hero>
      <div>
        <h1 :class="$style.pageNotFoundCode">404</h1>
        <strong>Страница не найдена</strong>
      </div>
    </Hero>
    <div :class="$style.pageNotFoundDescription">Страница, на которую Вы хотели перейти, не найдена. Возможно, введен некорректный адрес или страница была удалена.</div>
  </div>
</template>

<script>
import Hero from 'components/Hero';

export default {
  name: 'PageNotFound',
  components: {
    Hero,
  },
};
</script>

<style lang="scss" module scoped>
@import '../styles/variables';

.pageNotFoundCode {
  margin: 0;
}

.pageNotFoundDescription {
  color: $red;
  text-align: center;
  font-size: 18px;
  max-width: 420px;
  margin: 90px auto;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/views/PageNotFound.vue